import { createSvgIcon } from "@mui/material";

export const LeafIcon = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.01514 1.00223C2.60624 0.900666 8.00848 1.57306 10.0142 3.50321L10.1997 3.68876C11.5034 5.0463 12.4965 7.1916 12.896 9.50321C13.3981 8.82509 13.9795 8.24171 14.6245 7.76981L15.0142 7.50223C17.1296 6.14974 21.6263 6.13045 23.0142 6.50223C22.5617 8.19071 22.3859 12.1657 19.5142 14.0022L19.2437 14.1683C17.2108 15.3643 14.9229 15.5751 13.0142 15.1897V23.0022H11.0142V13.0433C8.72573 13.1464 6.02796 12.4878 3.97119 10.6624L3.7124 10.4241C0.989343 7.80357 1.13864 2.93499 1.01514 1.00223ZM20.6021 8.29716C20.2465 8.30059 19.8574 8.31559 19.4487 8.34891C17.9626 8.47017 16.7203 8.78469 16.0913 9.1868C14.865 9.97106 13.819 11.3413 13.2954 13.2063C14.8335 13.5454 16.7677 13.3843 18.436 12.3177C19.3109 11.7582 19.8736 10.8153 20.2671 9.5872C20.4029 9.16316 20.5083 8.72977 20.6021 8.29716ZM3.12451 3.12821C3.16739 3.74649 3.23299 4.4086 3.35693 5.1038C3.64628 6.72621 4.18546 8.10336 5.09912 8.9827C6.7756 10.5958 9.13664 11.1618 11.0669 11.0393C10.909 8.5318 9.87526 6.14465 8.62744 4.94364C8.38245 4.7079 7.92728 4.42017 7.22803 4.13407C6.55045 3.85686 5.75311 3.6253 4.92822 3.44364C4.29114 3.30336 3.67474 3.19985 3.12451 3.12821Z"
    />
  </svg>,
  "Leaf"
);
